import { conversion, type PeriodRange, type TimelineRange } from '@atlassian/eoc-schedule-common';

import { partitionDate } from '../../../../utils/date';

/**
 * Normalize the range of the period within the bounds of the outer range.
 */
const normalizeRange = (period: PeriodRange, outer: TimelineRange) => {
	const { startEpoch, endEpoch, endOffset } = period;
	const { nowEpoch, nowOffset } = outer;

	if (nowEpoch > startEpoch) {
		return {
			startEpoch: nowEpoch,
			startOffset: nowOffset,
			endEpoch,
			endOffset,
		};
	}

	return period;
};

const makeTime = (epoch: number, offset: number) => {
	return partitionDate(conversion.toLocal(epoch, offset));
};

export { normalizeRange, makeTime };
